<template>
    <div class="NavigationalHeader">
        <div class="NavigationalHeader__backButtonWithTitle">
            <NewButton
                variant="flat"
                color="neutral"
                size="icon-sm"
                class="NavigationalHeader__backButton"
                aria-label="Back"
                @click="$emit('back')"
            >
                <FontAwesomeIcon :icon="faAngleLeft" />
            </NewButton>
            <LabelBadge v-if="scopeLabel" class="NavigationalHeader__scopeBadge" color="warning" size="sm">
                {{ scopeLabel }}
            </LabelBadge>
            <div
                v-if="title != null && title !==''"
                class="NavigationalHeader__title ellipsis"
                :title="combinedTitle"
            >
                <span>{{ combinedTitle }}</span>
            </div>
            <EmptyValueDashSymbol v-else />
        </div>
        <Navigation
            :current-position="currentPosition"
            :max-position="maxPosition"
            @next="$emit('next')"
            @previous="$emit('previous')"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { faAngleLeft } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import LabelBadge from '@evidentid/dashboard-commons/components/LabelBadge/LabelBadge.vue';

    import NewButton from '@/components/new-button/NewButton.vue';
    import EmptyValueDashSymbol
        from '@/modules/entity-actions-review/components/EmptyValueDashSymbol/EmptyValueDashSymbol.vue';
    import Navigation from '@/modules/entity-actions-review/components/Navigation/Navigation.vue';

    @Component({
        emits: [ 'back', 'next', 'previous' ],
        components: { EmptyValueDashSymbol, FontAwesomeIcon, LabelBadge, Navigation, NewButton },
    })
    export default class NavigationalHeader extends Vue {
        @Prop({ type: String, default: '' })
        private title!: string;

        @Prop({ type: Number, default: 0 })
        private currentPosition!: number;

        @Prop({ type: Number, default: 0 })
        private maxPosition!: number;

        @Prop({ type: String, default: '' })
        private titlePrefix!: string;

        @Prop({ type: String, default: '' })
        private scopeLabel!: string;

        private faAngleLeft = faAngleLeft;

        private get combinedTitle(): string {
            return this.titlePrefix ? `${this.titlePrefix} - ${this.title}` : this.title;
        }
    }
</script>
